import L from 'leaflet';

import secondaryIconAccessImg from '../assets/images/secondary-icon-access.png';
import secondaryIconCoalitionImg from '../assets/images/secondary-icon-coalition.png';
import secondaryIconEquipmentImg from '../assets/images/secondary-icon-equipment.png';
import secondaryIconLiteracyImg from '../assets/images/secondary-icon-literacy.png';
import secondaryIconImg from '../assets/images/secondary-icon.png';
import accessIconImg from '../assets/images/access-icon.png';
import coalitionIconImg from '../assets/images/coalition-icon.png';
import equipmentIconImg from '../assets/images/equipment-icon.png';
import literacyIconImg from '../assets/images/literacy-icon.png';

const secondaryIconAccess = L.icon({
    iconUrl: secondaryIconAccessImg,
    iconRetinaUrl: secondaryIconAccessImg,
    iconAnchor: [5, 5],
    popupAnchor: [0, -3],
    iconSize: [10, 10],
});

const secondaryIconCoalition = L.icon({
    iconUrl: secondaryIconCoalitionImg,
    iconRetinaUrl: secondaryIconCoalitionImg,
    iconAnchor: [5, 5],
    popupAnchor: [0, -3],
    iconSize: [10, 10],
});

const secondaryIconEquipment = L.icon({
    iconUrl: secondaryIconEquipmentImg,
    iconRetinaUrl: secondaryIconEquipmentImg,
    iconAnchor: [5, 5],
    popupAnchor: [0, -3],
    iconSize: [10, 10],
});

const secondaryIconLiteracy = L.icon({
    iconUrl: secondaryIconLiteracyImg,
    iconRetinaUrl: secondaryIconLiteracyImg,
    iconAnchor: [5, 5],
    popupAnchor: [0, -3],
    iconSize: [10, 10],
});

const secondaryIcon = L.icon({
    iconUrl: secondaryIconImg,
    iconRetinaUrl: secondaryIconImg,
    iconAnchor: [5, 5],
    popupAnchor: [0, -3],
    iconSize: [10, 10],
});

const accessIcon = L.icon({
    iconUrl: accessIconImg,
    iconRetinaUrl: accessIconImg,
    iconAnchor: [17, 30],
    popupAnchor: [0, -20],
    iconSize: [34, 34],
});

const coalitionIcon = L.icon({
    iconUrl: coalitionIconImg,
    iconRetinaUrl: coalitionIconImg,
    iconAnchor: [17, 30],
    popupAnchor: [0, -20],
    iconSize: [34, 34],
});

const equipmentIcon = L.icon({
    iconUrl: equipmentIconImg,
    iconRetinaUrl: equipmentIconImg,
    iconAnchor: [17, 30],
    popupAnchor: [0, -20],
    iconSize: [34, 34],
});

const literacyIcon = L.icon({
    iconUrl: literacyIconImg,
    iconRetinaUrl: literacyIconImg,
    iconAnchor: [17, 30],
    popupAnchor: [0, -20],
    iconSize: [34, 34],
});

export default { secondaryIconAccess, secondaryIconCoalition, secondaryIconEquipment, secondaryIconLiteracy, secondaryIcon, accessIcon, coalitionIcon, equipmentIcon, literacyIcon };